import { usePageHeader } from "@hooks/use_page_header";
import { linkPage } from "@utils/router";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Select } from "antd";
import { Mading } from "@services/dtos/home.dto";
import { useQuery } from "@tanstack/react-query";
import { HomeService } from "@services/home.service";
import { LuInbox } from "react-icons/lu";
import { Spiner } from "@components/loaders/spiner";
import moment from "moment";
import { FilterOutlined } from "@ant-design/icons";
import { PopupCustom } from "@components/general/popup";

export const MadingListPage = () => {
  const navigate = useNavigate();
  usePageHeader("Informasi Terkini", { bottomNavigation: "hidden" });
  const [limit, setLimit] = useState<string>("10");
  const [popupFilter, setPopupFilter] = useState<boolean>(false);

  const kategori = "*";
  const { data: dataMading, isPending: isPendingMading } = useQuery({
    queryKey: [HomeService.queries.GET_MADING, kategori, limit],
    queryFn: () => HomeService.mading(kategori, limit),
  });


  const openDetailMading = (detailMading: Mading) => {
    navigate(linkPage.MADING_DETAIL, { state: detailMading });
  };

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        {/* filter bar */}
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-4">
          <div className="tw-text-sm tw-text-text-secondary">
            Menampilkan{" "}
            <span className="tw-font-semibold tw-text-text-primary">
              {limit} data terakhir
            </span>
          </div>
          <FilterOutlined
            className="tw-p-2 tw-text-xl tw-bg-transparent card-body"
            onClick={() => setPopupFilter(true)}
          />
        </div>

        {isPendingMading ? (
          <div className="tw-text-center card-body tw-py-8">
            <Spiner />
          </div>
        ) : dataMading?.data != null && dataMading.data.length > 0 ? (
          <div className="tw-space-y-3">
            {dataMading.data.map((item, idx) => (
              <div
                key={idx}
                onClick={() => openDetailMading(item)}
                className="tw-relative tw-rounded-2xl tw-overflow-hidden tw-min-h-[160px] tw-cursor-pointer"
                style={{
                  backgroundImage: `url(${item.gambar})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div
                  className="tw-absolute tw-inset-0"
                  style={{
                    background:
                      "linear-gradient(to bottom, transparent 30%, rgba(15,23,42,0.85))",
                  }}
                />
                <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-p-4">
                  <div className="tw-text-[10px] tw-text-white/60 tw-mb-1">
                    {moment(item.tanggal ?? Date.now()).format("DD MMMM YYYY")}
                  </div>
                  <div className="tw-text-sm tw-font-semibold tw-text-white tw-truncate">
                    {item.judul}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="tw-p-8 tw-text-center card-body">
            <LuInbox className="tw-mx-auto tw-mb-2 tw-text-5xl tw-text-text-secondary tw-opacity-40" />
            <div className="tw-text-sm tw-text-text-secondary">
              Data tidak ditemukan
            </div>
          </div>
        )}
      </div>

      <PopupCustom
        title="Filter Data"
        open={popupFilter}
        onCancel={() => setPopupFilter(false)}
        slideUpModal={true}
      >
        <Select
          className="tw-text-base"
          placeholder="Pilih Jumlah Ditampilkan"
          defaultValue={limit}
          style={{ width: "100%" }}
          allowClear
          onChange={(e) => setLimit(e)}
          options={[
            { value: "10", label: "10 data terakhir" },
            { value: "25", label: "25 data terakhir" },
            { value: "50", label: "50 data terakhir" },
          ]}
        />
        <Button
          onClick={() => setPopupFilter(false)}
          className="tw-p-2 tw-mt-6 tw-h-10 tw-w-full tw-text-sm tw-rounded-xl tw-border-0 tw-text-white focus:tw-shadow-none"
          style={{ background: "#ef4444" }}
        >
          Tutup
        </Button>
      </PopupCustom>
    </>
  );
};
